import useScript from "@hooks/useScript";

import { TWITTER_SDK } from "./constants";

export type XEmbedCustomProps = {
  url: string;
};

export default function XEmbedCustom({
  url,
}: XEmbedCustomProps): React.ReactElement {
  useScript({ id: "twitter-embed-script", src: TWITTER_SDK, async: true });

  return (
    <div className="flex justify-center">
      <blockquote className="twitter-tweet">
        <a href={url}>{url}</a>
      </blockquote>
    </div>
  );
}
